import { defineStore } from 'pinia'

export const useExportStore = defineStore('export', {
  state: () => ({
    isExporting: false,
    exportProgress: 0,
    exportStatus: '', // 'pending', 'processing', 'completed', 'failed'
    exportMessage: '',
    progressInterval: null
  }),
  
  actions: {
    startExport(message = 'Exportando...') {
      this.isExporting = true
      this.exportProgress = 0
      this.exportStatus = 'pending'
      this.exportMessage = message
      
      // Iniciar la animación gradual del progreso con un intervalo más largo
      this.progressInterval = setInterval(() => {
        if (this.exportProgress < 90) {
          // Incrementar muy gradualmente hasta 90%
          const increment = Math.min(1, (90 - this.exportProgress) / 100)
          this.exportProgress = Math.min(90, this.exportProgress + increment)
        }
      }, 300)
    },
    
    updateProgress(progress) {
      // Solo actualizar si es menor que 90 para mantener la animación gradual
      if (progress < 90) {
        this.exportProgress = progress
      }
    },
    
    setStatus(status, message) {
      this.exportStatus = status
      this.exportMessage = message
    },
    
    completeExport() {
      // Limpiar el intervalo de progreso
      if (this.progressInterval) {
        clearInterval(this.progressInterval)
      }
      
      // Llenar instantáneamente hasta 100%
      this.exportProgress = 100
      this.isExporting = false
      this.exportStatus = 'completed'
      this.exportMessage = 'Exportación completada'
    },
    
    failExport(message = 'Error en la exportación') {
      // Limpiar el intervalo de progreso
      if (this.progressInterval) {
        clearInterval(this.progressInterval)
      }
      
      this.isExporting = false
      this.exportStatus = 'failed'
      this.exportMessage = message
    }
  }
}) 